import React, { useContext, useEffect, useState } from "react";
import styles from "./styles/TableFooter.module.css";
import { LanguageContext } from "../../../Context/changeLanguageProvider";

function TableFooter({
  setPageSize,
  pageSize,
  maxPage,
  previousPage,
  nextPage,
  canNextPage,
  canPreviousPage,
  pageIndex,
  scrollToTop
}) {
  const websiteCurrentLang = useContext(LanguageContext).language;

  const [content, setContent] = useState(
    websiteCurrentLang.content.User.TableFooter.TableFooter
  );
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );

  useEffect(() => {
    setContent(websiteCurrentLang.content.User.TableFooter.TableFooter);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);

  return (
    <div className={styles.footer}>
      {/* <input className={styles.log_input} onChange={(e)=>null} value={pageSize}></input> */}
      <select
        value={pageSize}
        onChange={(e) => {
          setPageSize(Number(e.target.value));
        }}
        className={styles.select}
      >
        {[5, 10, 15].map((e) => {
          return (
            <option key={e} value={e}>
              {e}
            </option>
          );
        })}
      </select>
      <div className={styles.buttons_div}>
        <button
          onClick={() => previousPage()}
          disabled={!canPreviousPage}
          className={styles.pagination}
        >
          {content.tableFooterText1}
        </button>
        <div className={styles.page_number}>
          {content.tableFooterText2} {pageIndex + 1}{" "}
          {dublicatedcontent?.of?.toLowerCase()} {maxPage}
        </div>
        <button
          onClick={() => {
            if(scrollToTop) window.scrollTo(0, 0);
            nextPage();
          }}
          disabled={!canNextPage}
          className={`${styles.pagination} ${styles.pagination_next}`}
        >
          {dublicatedcontent.dublicatedText72}
        </button>
      </div>
    </div>
  );
}

export default TableFooter;
